import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  list = 1,
  firework,
  rewards,
}

// 获取基础配置信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=27720945
export const new_year_rank_config = createAsyncThunk(
  'new_year_rank_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'fire_work_rank_id' | 'send_rank_id' | 'receive_rank_id'
        >
      >
    >(
      '/live/commonactivity/new_year_rank_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

interface HiyaRes<T> {
  ret: number
  data: T
}

interface InitialStateType {
  tab_id?: number
  send_rank_id?: number
  receive_rank_id?: number
  fire_work_rank_id?: number
}
const initialState: InitialStateType = {}
export const NewYear2021Slice = createSlice({
  name: 'NewYear2021',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(new_year_rank_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default NewYear2021Slice.reducer
